"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerQualityIssue = void 0;
var PowerQualityIssue;
(function (PowerQualityIssue) {
    PowerQualityIssue[PowerQualityIssue["None"] = 1] = "None";
    PowerQualityIssue[PowerQualityIssue["Unspecified"] = 2] = "Unspecified";
    PowerQualityIssue[PowerQualityIssue["CouplerOvertemp"] = 3] = "CouplerOvertemp";
    PowerQualityIssue[PowerQualityIssue["CouplerTempSensorError"] = 4] = "CouplerTempSensorError";
    PowerQualityIssue[PowerQualityIssue["CoolantShortage"] = 5] = "CoolantShortage";
    PowerQualityIssue[PowerQualityIssue["TankIssue"] = 6] = "TankIssue";
    PowerQualityIssue[PowerQualityIssue["HeaterIssue"] = 7] = "HeaterIssue";
    PowerQualityIssue[PowerQualityIssue["HighPressure"] = 8] = "HighPressure";
    PowerQualityIssue[PowerQualityIssue["PumpIssue"] = 9] = "PumpIssue";
    PowerQualityIssue[PowerQualityIssue["FanIssue"] = 10] = "FanIssue";
    PowerQualityIssue[PowerQualityIssue["LowPressure"] = 11] = "LowPressure";
    PowerQualityIssue[PowerQualityIssue["PressureSensorIssue"] = 12] = "PressureSensorIssue";
    PowerQualityIssue[PowerQualityIssue["OutletTempSensorError"] = 13] = "OutletTempSensorError";
    PowerQualityIssue[PowerQualityIssue["HexTempSensorError"] = 14] = "HexTempSensorError";
})(PowerQualityIssue = exports.PowerQualityIssue || (exports.PowerQualityIssue = {}));
